import { Typography } from '@mui/material';
import { observer } from 'mobx-react';
import React from 'react';
import { IPartes } from '../../modelo/Partes';
import { Partes } from '../../modelo/dominio/Partes';
import dadosProcessoStore from '../../store/ProcessoExpandidoStore';
import '../css/partes.css';
import ViewListParte from './ViewListParte';

interface IProps {
    partes: Partes;
    mensagemErro?: string;
}

export const ViewPartesProcesso = observer(class ViewPartesProcesso extends React.Component<IProps> {
    get partes(): IPartes {
        const partes = this.props.partes || dadosProcessoStore.dadosProcesso.partes;
        if (!partes?.ATIVO && !partes?.PASSIVO && !partes?.TERCEIROS) {
            return {} as IPartes;
        }

        return {
            ATIVO: [...partes.ATIVO || []],
            PASSIVO: [...partes.PASSIVO || []],
            TERCEIROS: [...partes.TERCEIROS || []]
        };
    }

    render() {
        const mensagemErro = this.props.mensagemErro;
        if (mensagemErro) {
            return (
                <div>
                    <Typography component='b' variant='h6' className="titulo" tabIndex={2}>
                        Partes:
                    </Typography>
                    <Typography color='error' style={{ whiteSpace: 'pre-line' }}>
                        {mensagemErro}
                    </Typography>
                </div>
            );
        }
        if (!this.props.partes && !dadosProcessoStore.dadosProcesso.partes) {
            return (
                <div>
                    <Typography component='b' variant='h6' className="titulo">Não foram encontradas partes no processo. Favor verifique a autuação do processo.</Typography>
                </div>
            );
        }
        return (
            <>
                <Typography component='b' variant='h6' className="titulo" tabIndex={2}>Partes:</Typography>
                <ul className='divFlexRow'>
                    <div className='divFlexColumn'>
                        {this.partes.ATIVO && this.partes.ATIVO.map(parte => {
                            return (
                                <ViewListParte parte={parte} key={'ativo-parte-' + parte.nome} />
                            );
                        })}
                    </div>
                    {this.partes.PASSIVO && this.partes.PASSIVO[0] &&
                        <div className={this.partes.ATIVO ? 'bordaEsquerdaParte ' : ''}>
                            {this.partes.PASSIVO.map(parte => {
                                return (
                                    <ViewListParte parte={parte} key={'passivo-parte-' + parte.nome} />
                                );
                            })}
                        </div>
                    }
                    {this.partes.TERCEIROS && this.partes.TERCEIROS[0] &&
                        <div className={this.partes.PASSIVO ? 'bordaEsquerdaParte' : ''}>
                            {this.partes.TERCEIROS.map(parte => {
                                return (
                                    <ViewListParte parte={parte} key={'terceiro-parte-' + parte.nome} />
                                );
                            })}
                        </div>
                    }
                </ul >
            </>
        );
    }
});
